import { foldText } from "./textSearch.js";

export function normalizeIdentityQuery(query) {
  return foldText(query).trim().replace(/\s+/g, " ");
}

// Explicit descriptors only: never serialize records, notes, or child entities.
// Evidence order follows descriptor order and preserves original display values.
export function matchIdentity(query, fields) {
  const normalized = normalizeIdentityQuery(query);
  if (!normalized) return { eligible: true, tier: 1, evidence: null };
  const terms = normalized.split(" ");
  const candidates = fields.filter((f) => typeof f.value === "string" && f.value.trim())
    .map((f) => ({ ...f, folded: normalizeIdentityQuery(f.value) }));
  const eligible = terms.every((term) => candidates.some((f) => f.folded.includes(term)));
  if (!eligible) return { eligible: false, tier: 1, evidence: null };
  const tier = candidates.some((f) => f.primary && f.folded.startsWith(normalized)) ? 0 : 1;
  const hiddenTerms = terms.filter((term) => !candidates.some((f) => f.visible && f.folded.includes(term)));
  const evidence = candidates.find((f) => !f.visible && hiddenTerms.some((term) => f.folded.includes(term)));
  return { eligible, tier, evidence: evidence?.displayValue ?? evidence?.value ?? null };
}

// Run AFTER the ordinary sort. Partitioning preserves every within-tier tie.
export function rankIdentityMatches(rows, matches) {
  if (!matches?.size) return rows;
  const primary = [];
  const secondary = [];
  for (const row of rows) {
    (matches.get(row.id)?.tier === 0 ? primary : secondary).push(row);
  }
  return [...primary, ...secondary];
}
